import { Directive, ElementRef, Input, OnChanges, Renderer2, SimpleChanges } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator, NgControl } from '@angular/forms';

@Directive({
  selector: '[appValidateDocument]',
  providers: [{provide: NG_VALIDATORS, useExisting: ValidateDocumentDirective, multi: true}]
})
export class ValidateDocumentDirective implements Validator, OnChanges {

  @Input() typeDocument: any;
  
  constructor(
    protected elementRef?: ElementRef,
    protected render?: Renderer2
  ) { }

  private invalidStartDigits = ['8', '9'];
  
  validate(control: AbstractControl): ValidationErrors {
    return this.validateDocumentForLength(control.value);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.typeDocument){
      this.validateDocumentForLength(this.elementRef.nativeElement.value);
    }
  }


  validateDocumentForLength(value?: any) {
    const element = this.elementRef.nativeElement;
    if (value){
      if(String(value).length < 4) return {'documentInvalid': {'message': 'Documento inválido.'}};
      if(this.typeDocument === 'C') {
        element.setAttribute("maxlength",10);
        if(String(value).length === 9 || (String(value).length === 10 && this.validateInitialNumber(value))) {
          this.classInvalid();
          return {'documentInvalid': {'message': 'Documento inválido.'}};
        } 
        this.classValid();
        return null;
      };

      if(this.typeDocument === 'E') {
        element.setAttribute("maxlength",8);
        if(String(value).length > 8) {
          element.value = element.value.slice(0,8);
          return {'documentInvalid': {'message': 'Documento inválido.'}};
        } 
        return null;
      };

      if(this.typeDocument === 'N') {
        element.setAttribute("maxlength",10);
      }
    }
  }

  validateInitialNumber(value: any) {
    const firstDigit = String(value).charAt(0);
    return  this.invalidStartDigits.includes(firstDigit);
  }

  classValid() {
    this.render.removeClass(this.elementRef.nativeElement,'ng-invalid');
    this.render.addClass(this.elementRef.nativeElement,'ng-valid');
  }
  
  classInvalid() {
    this.render.removeClass(this.elementRef.nativeElement,'ng-valid');
    this.render.addClass(this.elementRef.nativeElement,'ng-invalid');  
  }

}
